import { render } from "./ForwardMessage.vue?vue&type=template&id=67b981e6&scoped=true"
import script from "./ForwardMessage.vue?vue&type=script&lang=js"
export * from "./ForwardMessage.vue?vue&type=script&lang=js"

import "./ForwardMessage.vue?vue&type=style&index=0&id=67b981e6&lang=scss&scoped=true"
import "./ForwardMessage.vue?vue&type=style&index=1&id=67b981e6&lang=scss"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b981e6"]])

export default __exports__